import React from "react";
import styles from "./top-nav.module.scss";
import logoPng from "../../../../assets/myota_logo_white_type.png";
import { StepsIndicator } from "../steps-indicator/steps-indicator";

interface ITopNavProps {}

const TopNav = function(props: ITopNavProps) {
  return (
    <div className={styles.root}>
      <div className={styles.logo}>
        <img className={styles["logo-image"]} src={logoPng} alt="Myota-logo" />
      </div>
      <div className={styles["step-indicator"]}>
        <StepsIndicator isHorizontal={true}/>
      </div>
    </div>
  );
};

export default TopNav;